import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { CorsoModulo } from 'src/app/model/corsomodulo';
import { ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import { ModuloService } from 'src/app/service/modulo.service';
import { Corso } from 'src/app/model/corso';
import { CourseService } from 'src/app/service/course.service';

@Component({
  selector: 'app-modulo',
  templateUrl: './modulo.component.html',
  styleUrls: ['./modulo.component.css']
})
export class ModuloComponent implements OnInit {
    corso: Corso;
    modulo: CorsoModulo;
    moduloParentsStruct: Array<CorsoModulo>;
    courseId: number; 
    @ViewChild('downloadModuloLink') private downloadModuloLink: ElementRef;

    constructor(
        private route: ActivatedRoute,
        private corsoSrv: CourseService,
        private moduloSrv: ModuloService
    ) { }

    ngOnInit() {
        this.route.paramMap.subscribe(params =>  {
            // save courseId
            this.courseId = +params.get('courseId');
            // load moduli and corsi
            this.loadCorso(+params.get('courseId'));
            this.loadModulo(+params.get('moduloId'));
            this.loadModuloParentsStruct(+params.get('moduloId'));
        });
    }

    changeModulo(modulo: CorsoModulo) {
        this.modulo = modulo;
    }

    public async downloadModulo(modulo: CorsoModulo): Promise<void> {
        const blob = await this.moduloSrv.downloadResource(this.courseId, modulo.id);
        if ('navigator' in window && 'msSaveOrOpenBlob' in navigator) {
            //@ts-ignore
            window.navigator.msSaveOrOpenBlob(blob, modulo.fileLezionePdf);
        } else {
            const url = window.URL.createObjectURL(blob);
            const link = this.downloadModuloLink.nativeElement;
            link.href = url;
            link.download = modulo.fileLezionePdf;
            link.click();
            window.URL.revokeObjectURL(url);
        }
    }

    private loadCorso(courseId: number) {
        this.corsoSrv.getCourse(courseId)
        .pipe(first())
            .subscribe(
                data => {
                    this.corso = data;
                },
                error => {
                    return;
                }
            );
    }

    private loadModulo(moduloId: number) {
        this.moduloSrv.getModuloFigli(moduloId)
        .pipe(first())
            .subscribe(
                data => {
                    this.modulo = data;
                },
                error => {
                    return;
                }
            );
    }

    private loadModuloParentsStruct(moduloId: number) {
        this.moduloSrv.getModuleParentsStruct(moduloId)
        .pipe(first())
            .subscribe(
                data => {
                    this.moduloParentsStruct = data;
                },
                error => {
                    return;
                }
            );
    }
}
